import Vue from 'vue'
import Checkbox from '@/components/base/Checkbox'
import ImageUpload from '@/components/base/ImageUpload'
import GalleryInput from '@/components/base/GalleryInput'
import FileUpload from '@/components/base/FileUpload'
import TextField from '@/components/base/TextField'
import NumberRangeField from '@/components/base/NumberRange'
import TextArea from '@/components/base/TextArea'
import Dropdown from '@/components/base/Dropdown'
import Lightswitch from '@/components/base/Lightswitch'
import Matrix from '@/components/base/Matrix'
import Date from '@/components/base/Date'
import DynamicRow from '@/components/tablefields/DynamicRow'

Vue.component('checkbox', Checkbox)
Vue.component('dropdown', Dropdown)
Vue.component('image-upload', ImageUpload)
Vue.component('gallery-input', GalleryInput)
Vue.component('file-upload', FileUpload)
Vue.component('text-field', TextField)
Vue.component('number-range', NumberRangeField)
Vue.component('text-area', TextArea)
Vue.component('lightswitch', Lightswitch)
Vue.component('matrix', Matrix)
Vue.component('date', Date)
Vue.component('dynamic-row', DynamicRow)
